<template>
  <div class="testimonials_main container">
    <h3>REVIEWS</h3>
    <div class="testimonials_main__inner">
      <div v-for="item in results" v-bind:key="item.id" class="review">
        <h1 class="headline">{{ item.headline }}</h1>
        <div class="body">
          <p class="rating">
            {{ item.rating }}/5
            <font-awesome-icon style="color: #ffbf00" :icon="['fas', 'star']" />
          </p>

          <p class="date">{{ item.date }}</p>
          <p class="reviewer_name">{{ item.reviewer_nickname }}</p>
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      results: [],
    };
  },
  props: {
    url: String,
  },
  async mounted() {
    let url = this.url;
    await axios.get(url).then((response) => {
      let responseData = response.data;
      this.results = responseData.reviews.slice(0, 3);
    });
  },
};
</script>

<style lang="scss">
@import "../styles/main";

.testimonials_main {
  font-family: "Raleway", sans-serif;
  margin-top: 40px;
  &__inner {
    display: flex;
    justify-content: space-between;
    @media only screen and (max-width: 1000px) {
      margin-top: 20px;
      display: block;
    }
  }
  h3 {
    margin-bottom: 40px;
  }
  h1 {
    font-weight: 800;
    font-size: 24px;
    color: $text--blue--dark;
  }
  .rating {
    font-size: 18px;
  }
  p {
    font-weight: 600;
    font-size: 12px;
  }
}
</style>
